import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(
    () => ({
        '@keyframes spin': {
            '0%': {
                transformOrigin: '50% 50%',
            },
            '100%': {
                transform: 'rotate(360deg)',
            },
        },
        root: {
            '& > svg': {
                animation: '$spin 0.9s linear infinite',
                display: 'inline-block',
            },
        },
    }),
    { name: 'MuiColorfulProgress' },
);

export default useStyles;
